var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetroLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.28,
    height: 13.496,
    viewBox: "0 0 19.28 13.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-lines",
    "data-name": "Icon metro-lines",
    d: "M9.319,11.568H26.671a.964.964,0,0,0,0-1.928H9.319a.964.964,0,0,0,0,1.928ZM26.671,13.5H9.319a.964.964,0,1,0,0,1.928H26.671a.964.964,0,0,0,0-1.928Zm0,3.856H9.319a.964.964,0,1,0,0,1.928H26.671a.964.964,0,0,0,0-1.928Zm0,3.856H9.319a.964.964,0,1,0,0,1.928H26.671a.964.964,0,0,0,0-1.928Z",
    transform: "translate(-8.355 -9.64)",
    fill: "#897f7f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroLines);
export default __webpack_public_path__ + "static/media/metro-lines.7465a1242995bdd4947973b4398a7af9.svg";
export { ForwardRef as ReactComponent };